"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _reactColorful = require("react-colorful");

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var _ramda = require("ramda");

var _Icon = require("../Icon");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    colorBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      border: function border(_ref2) {
        var isWhite = _ref2.isWhite;
        return isWhite ? "1px solid ".concat(palette.grey.light) : 'none';
      }
    },
    modalPaper: {
      overflow: 'unset'
    },
    clearButton: {
      minWidth: 40
    }
  };
});
var WHITE_HEX = '#ffffff';
var alignColor = (0, _ramda.pipe)(_ramda.trim, _ramda.toLower);

var ColorPicker = function ColorPicker(_ref3) {
  var value = _ref3.value,
      onChange = _ref3.onChange,
      _ref3$fieldProps = _ref3.fieldProps,
      fieldProps = _ref3$fieldProps === void 0 ? {} : _ref3$fieldProps,
      _ref3$wrapperProps = _ref3.wrapperProps,
      wrapperProps = _ref3$wrapperProps === void 0 ? {} : _ref3$wrapperProps;
  var hexString = (0, _react.useMemo)(function () {
    return value.startsWith('rgb') ? value : (0, _tinycolor["default"])(value).toHexString();
  }, [value]);
  var isWhite = hexString === WHITE_HEX;
  var _fieldProps$disabled = fieldProps.disabled,
      disabled = _fieldProps$disabled === void 0 ? false : _fieldProps$disabled;
  var classes = useStyles({
    isWhite: isWhite
  });

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);
  var id = open ? 'simple-popover' : undefined;
  var handleChangeInput = (0, _react.useCallback)(function (_ref4) {
    var target = _ref4.target;
    var colorValue = alignColor(target.value || '');
    var isClearValue = colorValue === '' || colorValue.startsWith('#') || colorValue.startsWith('r');
    var inputValue = isClearValue ? colorValue : "#".concat(target.value);
    onChange(inputValue);
  }, [onChange]);
  var handleClearInput = (0, _react.useCallback)(function () {
    onChange('');
  }, [onChange]);
  var handleOpenPicker = (0, _react.useCallback)(function (event) {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  }, [disabled]);
  var handleClosePicker = (0, _react.useCallback)(function () {
    return setAnchorEl(null);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start"
  }, wrapperProps), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.colorBox,
    minWidth: 48,
    height: 48,
    borderRadius: "5px",
    mr: 1,
    bgcolor: fieldProps.error ? WHITE_HEX : hexString,
    onClick: handleOpenPicker
  }, fieldProps.error && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    icon: "exclamation-circle",
    color: "red.main"
  })), /*#__PURE__*/_react["default"].createElement(_material.TextField, (0, _extends2["default"])({
    variant: "outlined",
    fullWidth: true,
    value: value,
    onChange: handleChangeInput,
    InputProps: {
      endAdornment: value && /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        className: classes.clearButton,
        "data-testid": "".concat(fieldProps.name || 'colorPicker', "-clearButton"),
        onClick: handleClearInput,
        variant: "text"
      }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
        icon: "times",
        color: "primary.main"
      })))
    }
  }, fieldProps)), /*#__PURE__*/_react["default"].createElement(_material.Popover, {
    id: id,
    classes: {
      paper: classes.modalPaper
    },
    open: open,
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    onClose: handleClosePicker
  }, /*#__PURE__*/_react["default"].createElement(_reactColorful.HexColorPicker, {
    color: hexString,
    onChange: onChange
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(ColorPicker);

exports["default"] = _default;